import { IonicModule } from '@ionic/angular';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiMobileModule } from '@usucampeao/ui-mobile';
import { RegistrationHelpModal } from './registration-help.modal';

@NgModule({
  declarations: [RegistrationHelpModal],
  imports: [
    CommonModule,
    IonicModule,
    UiMobileModule,
  ],
  exports:[RegistrationHelpModal],
})
export class RegistrationHelpModule {}
